import React, { Component, Fragment } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Img from "gatsby-image";
import Flex, { FlexItem } from "styled-flex-component";
import Helmet from "react-helmet";
import { Title, CenteredFull } from "../components/Typography";
import { Heading, Badge, Strong, Paragraph, Pane } from "evergreen-ui";
import Gallery from "react-photo-gallery";
import Lightbox from "react-images";

export default class OurHomePage extends Component {
	state = {
		currentImage: 0
	};

	openLightbox = (event, obj) => {
		this.setState({
			currentImage: obj.index,
			lightboxIsOpen: true
		});
	};

	closeLightbox = () => {
		this.setState({
			currentImage: 0,
			lightboxIsOpen: false
		});
	};

	gotoPrevious = () => {
		this.setState({
			currentImage: this.state.currentImage - 1
		});
	};

	gotoNext = () => {
		this.setState({
			currentImage: this.state.currentImage + 1
		});
	};

	render() {
		const { markdownRemark: data } = this.props.data;

		const PHOTO_SET = data.frontmatter.images.map(image => ({
			width: image.childImageSharp.original.width,
			height: image.childImageSharp.original.height,
			src: image.childImageSharp.sizes.src,
			srcSet: image.childImageSharp.sizes.srcSet,
			sizes: image.childImageSharp.sizes.sizes,
			key: image.childImageSharp.sizes.originalName
		}));
		return (
			<Fragment>
				<Helmet title={data.frontmatter.title} />
				<CenteredFull>
					<Title>{data.frontmatter.title}</Title>
				</CenteredFull>
				<SectionContainer>
					<Gallery onClick={this.openLightbox} columns={3} margin={5} photos={PHOTO_SET} />
					<Lightbox
						images={PHOTO_SET}
						onClose={this.closeLightbox}
						onClickPrev={this.gotoPrevious}
						onClickNext={this.gotoNext}
						currentImage={this.state.currentImage}
						isOpen={this.state.lightboxIsOpen}
					/>
					<Paragraph marginTop="4rem" dangerouslySetInnerHTML={{ __html: data.html }} />
				</SectionContainer>
			</Fragment>
		);
	}
}

const Decorator = styled(Img)`
	opacity: 0.5;
`;

const SectionContainer = styled.div`
	margin: 0 auto;
	max-width: 1000px;
	margin-bottom: 150px;
	margin-top: -4rem;
	padding: ${100 / 24 / 2}vw ${100 / 24}vw;
	position: relative;
	overflow: hidden;

	img {
		border-radius: 5px;
	}

	blockquote p {
		font-style: italic;
	}

	@media screen and (max-width: 1024px) {
		max-width: ${(100 / 12) * 10}vw;
		margin-top: auto;
	}
`;

export const HomeQuery = graphql`
	query OurHomePage($id: String!) {
		markdownRemark(id: { eq: $id }) {
			id
			html
			frontmatter {
				title
				images {
					childImageSharp {
						original {
							width
							height
						}
						sizes {
							src
							srcSet
							aspectRatio
							sizes
							originalName
						}
					}
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/our-home-page.jsx